<template>
  <div class="slide-type-list">
    <div
      v-for="typeObj in allTypeSections"
      :key="typeObj.type"
      class="overflow-hidden"
      :class="{
        [`slide-type-list-section-${typeObj.sectionKey}`]: true,
        'hidden': typeObj.sectionKey === 'hackathon' && !canUseHackathon2025Screen,
      }"
    >
      <div
        class="slide-type-section-label"
        :class="{
          'quiz': typeObj.sectionKey === 'quiz',
          'poll': typeObj.sectionKey === 'poll',
          'content': typeObj.sectionKey === 'content',
        }"
      >
        <aha-icon
          :name="typeObj.sectionIcon"
          class="icon mr-2"
          width="21"
          height="21"
          viewBox="0 0 21 21"
        >
        </aha-icon>
        <span class="text-base font-bold">{{ typeObj.sectionLabel }}</span>
      </div>
      <div class="slide-type-section-content" :class="{'quiz': typeObj.sectionKey === 'quiz'}">
        <component
          :is="'SlideTypeItem'"
          v-for="(item, index) in typeObj.slideTypes"
          :key="index"
          :item="item"
          :typeObj="typeObj"
          :wrapperId="wrapperId"
          :index="index"
          :loadingItem="loadingItem"
          :showSlideTypeTooltip="showSlideTypeTooltip"
          @handleHoverOnSlideType="handleHoverOnSlideType"
          @clickOutslideUpgrade="clickOutslideUpgrade"
          @handleSelectSlideType="handleSelectSlideType"
        >
        </component>
      </div>
      <div class="slide-type-section__import" v-if="typeObj.sectionKey === 'quiz'">
        <GenerateFromDoc />
        <ImportSheet />
      </div>
    </div>

    <!-- Integrations Section with feature flag -->
    <IntegrationsSection v-if="canShowIntegrationsSection" />

    <aha-modal
      @hide="selectedSmokeTestItem = null"
      v-if="selectedSmokeTestItem"
      :title="$i18nPresenter.t('smoke_test_underdevelopment')"
    >
      <p>{{ $i18nPresenter.t('smoke_test_beta_tester') }}</p>
      <template #action>
        <section class="flex gap-4">
          <aha-button @click.stop="signUpSmokeTest()">
            {{ $i18nPresenter.t('Sign me up!') }}
          </aha-button>
          <aha-button variant="white" @click="refuseSignup()">
            {{ $i18nPresenter.t('No thanks') }}
          </aha-button>
        </section>
      </template>
    </aha-modal>
    <aha-modal
      @hide="signedUpSmokeTest = false"
      :title="$i18nPresenter.t('Thank you! Stay tuned for updates from us!')"
      v-if="signedUpSmokeTest"
    >
      <template #action>
        <aha-button @click.stop="signedUpSmokeTest = false">
          {{ $i18nPresenter.t('Close') }}
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>

<script>
// components
import { mapGetters } from 'vuex'
import SlideTypeList from '@/components-v2/presentation-editor/new-slide/SlideTypeList.vue'
import IntegrationsSection from '@/components-v2/presentation-editor/new-slide/IntegrationsSection.vue'

export default {
  components: {
    SlideTypeItem: () => import('@/components-v2/presentation-editor/new-slide/SlideTypeItem.vue'),
    IntegrationsSection,
  },
  extends: SlideTypeList,
  computed: {
    ...mapGetters('featureToggles', ['isFeatureEnabled']),
    ...mapGetters('hackathong2025', [
      'canUseHackathon2025Screen',
    ]),
    canShowIntegrationsSection() {
      return this.isFeatureEnabled('release-promote-googleslides-33786')
    },
  },
  methods: {

  },
}
</script>
